import { render, staticRenderFns } from "./PatientView.vue?vue&type=template&id=0d200103&scoped=true"
import script from "./PatientView.vue?vue&type=script&lang=js"
export * from "./PatientView.vue?vue&type=script&lang=js"
import style0 from "./PatientView.vue?vue&type=style&index=0&id=0d200103&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d200103",
  null
  
)

export default component.exports